import moment from "moment";
import {
  getInvoicePartyAddress,
  getInvoicePartyContact,
  getInvoicePartyName,
  isGuestInvoice,
} from "./invoice";

/** Map saved invoice document → ThermalCustomerInvoice data. */
export const mapInvoiceToThermalReceipt = (invoice, options = {}) => {
  if (!invoice) return null;

  const items = (invoice.items || []).map((item) => ({
    name: item.name || "",
    qty: item.qty,
    price: item.price,
    amount: Number(item.amount ?? Number(item.qty || 0) * Number(item.price || 0)),
    unit: item.unit,
  }));

  const billTotal =
    items.reduce((s, i) => s + Number(i.amount || 0), 0) ||
    Number(invoice.total_amount || 0) + Number(invoice.discount || 0);

  const isGuest = isGuestInvoice(invoice);
  const printMode =
    options.printMode ?? (isGuest ? "hideItemPrices" : "full");

  return {
    customer: {
      name: getInvoicePartyName(invoice),
      contact: getInvoicePartyContact(invoice),
      address: getInvoicePartyAddress(invoice),
    },
    invoice_no: invoice.invoice_no || "",
    auto_invoice_no: invoice.auto_invoice_no ?? "",
    date: invoice.date
      ? moment.unix(invoice.date).format("YYYY-MM-DD")
      : options.date || moment().format("YYYY-MM-DD"),
    desc: invoice.desc || "",
    items,
    discount: Number(invoice.discount || 0),
    payment: Number(invoice.payment || 0),
    billTotal,
    saleType: options.saleType ?? (options.isReturn ? "RETURN" : "SALE"),
    invoiceCustomerType:
      invoice.invoice_customer_type || (isGuest ? "GUEST" : "CUSTOMER"),
    printMode,
  };
};

const formatSummaryRow = (row) => ({
  name: row?.name ?? "—",
  type: row?.type ?? "",
  price: Number(row?.price ?? 0),
  qty: Number(row?.qty ?? 0),
  amount: Number(row?.amount ?? 0),
  isTotal: row?.name === "Total",
});

/** Map item summary rows + party → ThermalItemSummary data. */
export const mapItemSummaryToThermalReceipt = ({
  title = "Item Summary",
  partyLabel = "Customer",
  partyName = "",
  partyContact = "",
  partyAddress = "",
  tabLabel = "All",
  rows = [],
  footer = {},
  showPrice = false,
}) => {
  const lineRows = (rows || [])
    .filter((r) => r && r.name)
    .map(formatSummaryRow);

  return {
    title,
    partyLabel,
    partyName,
    partyContact,
    partyAddress,
    tabLabel,
    showPrice: Boolean(showPrice),
    rows: lineRows,
    footer: {
      openingBalance: footer.openingBalance,
      discount: footer.discount,
      returnAmount: footer.returnAmount,
      paid: footer.paid,
      remaining: footer.remaining,
      totalAmount: footer.totalAmount,
      totalBox: footer.totalBox,
      totalShopping: footer.totalShopping,
    },
  };
};
